import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ModulePermissionsActions } from './module-permissions.actions';
import { ModulePermissionsService } from '../../service/module-permissions.service';

@Injectable()
export class ModulePermissionsEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(ModulePermissionsService);

  loadPermissions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ModulePermissionsActions.loadPermissions),
      switchMap(() =>
        this.service.getPermissions().pipe(
          map(permissions => ModulePermissionsActions.loadPermissionsSuccess({ permissions })),
          catchError(error => of(ModulePermissionsActions.loadPermissionsFailure({ error })))
        )
      )
    )
  );
}
